import React from "react";
import {useIntl} from "react-intl";
import {useDispatch} from "react-redux";
import {LazyLoadImage} from "react-lazy-load-image-component";
import PropTypes from "prop-types";
import get from "lodash/get";
import {getCurrentLocale} from "../../../../utils/language";
import {getAssetUrl} from "../../../../utils/commonHelper";
import {getMessages} from "../../../../tppServices/translations/messages";
import {setGenericEvent} from "../../../../store/actions/dataLayer";

const FooterDisclaimerLink = (props) => {
    const {context} = props;
    const messages = getMessages();
    const intl = useIntl();
    const {formatMessage: t} = intl;

    const dispatch = useDispatch();
    const trackGenericClick = (event) => () => {
        if (event) {
            dispatch(setGenericEvent('navigation - footer', event.action, event.label));
        }
    };

    return (
        <nav className="footer-disclaimers">
            <ul>
                {context.links.map(
                    ({props, name, event, img, alt, supportedLocales}) => {
                        // Need to remove href from props as it will be updated, but if updated here it will overwrite the original
                        // value as JS uses references as objects instead of the actual object.
                        // eslint-disable-next-line react/prop-types
                        const {href, ...newProps} = props;
                        newProps.href = get(messages, `footer.${href}`)
                            ? t(get(messages, `footer.${href}`))
                            : href;
                        const currentLocale = getCurrentLocale();

                        if (
                            supportedLocales &&
                            !supportedLocales.includes(currentLocale)
                        ) {
                            return null;
                        }

                        return (
                            <li key={name}>
                                <a {...newProps} onClick={trackGenericClick(event)}>
                                    {t(get(messages, `footer.${name}`), {
                                        date: new Date().getFullYear()
                                    })}
                                    {img && (
                                        <LazyLoadImage
                                            className="adchoices-icon"
                                            src={getAssetUrl(img)}
                                            alt={alt}
                                            threshold={200}
                                        />
                                    )}
                                </a>
                            </li>
                        );
                    }
                )}
            </ul>
        </nav>
    );
};

FooterDisclaimerLink.propTypes = {
    context: PropTypes.object
};

export default FooterDisclaimerLink;
